var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_13246_45888)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.5 0H7.5C3.35786 0 0 3.35786 0 7.5V24.5C0 28.6421 3.35786 32 7.5 32H24.5C28.6421 32 32 28.6421 32 24.5V7.5C32 3.35786 28.6421 0 24.5 0Z",
    fill: "#F4F2ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.2045 25.3798H9.18175V15.7207L3.5 11.4595V23.6753C3.5 24.6185 4.26425 25.3798 5.2045 25.3798Z",
    fill: "#4285F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.8184 25.38H26.7957C27.7389 25.38 28.5002 24.6157 28.5002 23.6755V11.4595L22.8184 15.7208",
    fill: "#34A853"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.8184 8.33447V15.7208L28.5002 11.4596V9.1866C28.5002 7.07872 26.094 5.87697 24.4094 7.14122",
    fill: "#FBBC04"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.18164 15.7207V8.33448L15.9998 13.4479L22.8179 8.33423V15.7206L15.9998 20.8344",
    fill: "#EA4335"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.5 9.1866V11.4593L9.18175 15.7207V8.33447L7.59088 7.14122C5.90338 5.87697 3.5 7.07872 3.5 9.1866Z",
    fill: "#C5221F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13246_45888"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGmail);
export default __webpack_public_path__ + "static/media/Gmail.e35c88f0629fb634974edeac4e1accbb.svg";
export { ForwardRef as ReactComponent };